"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Alert = _interopRequireDefault(require("@mui/material/Alert"));

var _AlertTitle = _interopRequireDefault(require("@mui/material/AlertTitle"));

var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));

var _Typography = _interopRequireDefault(require("@mui/material/Typography"));

var _CobaltIcon = _interopRequireDefault(require("../CobaltIcon"));

var _excluded = ["children", "className", "onClose", "closeText", "action"];
var defaultProps = {
  closeText: 'Fermer'
};

var Alert = function Alert(props) {
  var children = props.children,
      className = props.className,
      onClose = props.onClose,
      closeText = props.closeText,
      actionProp = props.action,
      others = (0, _objectWithoutProperties2["default"])(props, _excluded);

  var hasTitle = _react["default"].useMemo(function () {
    var has = false;

    _react["default"].Children.map(children, function (child) {
      has = has || child.type === _AlertTitle["default"];
    });

    return has;
  }, [children]);

  var action = !actionProp && onClose ? /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    size: "small",
    "aria-label": closeText,
    title: closeText,
    color: "inherit",
    onClick: onClose
  }, /*#__PURE__*/_react["default"].createElement(_CobaltIcon["default"], {
    name: "x"
  })) : undefined;
  return /*#__PURE__*/_react["default"].createElement(_Alert["default"], (0, _extends2["default"])({
    action: action
  }, others, {
    sx: {
      paddingLeft: hasTitle ? 0 : 4,
      '& .MuiAlert-message': {
        paddingRight: hasTitle ? 0 : undefined
      }
    }
  }), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body2",
    color: "inherit"
  }, children));
};

Alert.defaultProps = defaultProps;
var _default = Alert;
exports["default"] = _default;